import { Card } from "@/components/ui/Card";

const FeatureSection = ({ features }) => {
  return (
    <div className="bg-background-primary py-16 sm:py-20 lg:py-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-text-primary text-3xl md:text-3xl lg:text-4xl text-center mb-10 sm:mb-12 font-medium">Everything automated, nothing missed.</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;

            return (
              <Card key={index} className="bg-background-secondary rounded-xl p-4 sm:p-5 border border-white/5 shadow-sm">
                <div className="flex flex-col gap-2">
                  {/* Icon (hidden on mobile, visible on sm+) */}
                  <div className="flex gap-3 items-center">
                    <div className="hidden sm:flex w-9 h-9 rounded-lg bg-background-icon text-text-primary items-center justify-center shrink-0">
                      <Icon className="w-5 h-5" />
                    </div>

                    <div>
                      {/* Title */}
                      <h3 className="text-sm sm:text-base text-text-primary font-medium">
                        {/* Number only on mobile */}
                        <span className="sm:hidden">{index + 1}. </span>
                        {feature.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-xs sm:text-sm text-text-secondary mt-1 leading-relaxed">{feature.description}</p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeatureSection;
